import MonthlySpendCard from "./MonthlySpendCard";
import MonthlyUsageCard from "./MonthlyUsageCard";

const Monthly = ({
  setShowHowSpendCalculatedModal,
  setShowHowUsageCalculatedModal,
  setShowEditTariffModal,
}) => {
  return (
    <div className="space-y-6">
      <MonthlySpendCard
        setShowHowSpendCalculatedModal={setShowHowSpendCalculatedModal}
        showEditUsageForm={() => setShowEditTariffModal(true)}
      />

      <MonthlyUsageCard
        setShowHowUsageCalculatedModal={setShowHowUsageCalculatedModal}
        showEditUsageForm={() => setShowEditTariffModal(true)}
      />
    </div>
  );
};

export default Monthly;
